import { useContext } from 'react';

import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../Base';
import { LanguageSelect } from '../../components';
import styles from './PageHeader.module.css';
import SessionHttpContext from '../../store/session-http-context';

export const PageHeader = () => {
  const httpContext = useContext(SessionHttpContext);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage: string | undefined = i18n.resolvedLanguage;

  const langSwitcherOptions = [
    { value: 'et', label: t('general.lang.est') },
    { value: 'en', label: t('general.lang.eng') },
    { value: 'lv', label: t('general.lang.lat') },
    { value: 'lt', label: t('general.lang.lit') },
    { value: 'fr', label: t('general.lang.fra') },
    { value: 'de', label: t('general.lang.ger') },
    { value: 'nl', label: t('general.lang.nld') },
  ];

  const theme = useContext(ThemeContext);
  let imgSrc = '';

  if (theme.logo) {
    imgSrc = theme.logo.startsWith('data:image') ? theme.logo : `data:image/svg+xml;base64,${theme.logo}`;
  }
  return (
    <header className={styles.header}>
      <Stack
        className={styles.container}
        direction="row"
        sx={{
          justifyContent: imgSrc ? 'space-between' : 'end',
          alignItems: 'center'
        }}>
        {httpContext.isLoading ? (
          <div className={styles.logo}></div>
        ) : (
          <>
            {imgSrc && (
              <img
                className={styles.logo}
                src={imgSrc}
                alt={t('page.logo.alt')}
                {...{ 'data-testid': 'clientLogo' }}
              ></img>
            )}

            <LanguageSelect
              items={langSwitcherOptions}
              value={currentLanguage}
              onChange={changeLanguage}
            ></LanguageSelect>
          </>
        )}
      </Stack>
    </header>
  );
};
